import axios from 'axios';

const AdvanceService = {
  async getAdvances(loanId) {
    const response = await axios.get('/advance', {
      params: {
        loanId,
      },
    });

    return response.data;
  },
};

export default AdvanceService;
